export const numberRegex = /^[0-9]/;
export const nameRegex = /^[a-z ,.'-]+$/i;
export const lnameRegex = /^[a-z ,.'-]+$/i;
export const emailRegex = /\S+@\S+\.\S+/;
export const unameRegex = /\S+@\S+\.\S+/;
export const passwordRegex = /^[A-z][A-z0-9-_]{8,23}$/;
export const npointing=`https://6362595e7521369cd06b38a2.mockapi.io/portfolio`;
